import { useTranslation } from "react-i18next";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { WineColorEnum } from "@/constants/enums/wineColor.enum";
import { roundNumberToFixed } from "@/lib/money.util";
import { DisplayCaracteristic } from "@/components/pendingShipments/finalize/wineListElem";
import { WineListElem } from "./productElem";
import { Button } from "@/components/ui/button";
import { QuotationUpdateBoFormData } from "./expeditionsUpdateBoForm";

interface Props {
  hasScannedInvoice?: boolean;
  reExpedition?: boolean;
}

export const InfoBottlesBo = ({ hasScannedInvoice = false, reExpedition = false }: Props) => {
  const { t } = useTranslation("boExpeditionForm");
  const methods = useFormContext<QuotationUpdateBoFormData>();

  const defaultValues = hasScannedInvoice
    ? {
        wineName: "xxxx",
        year: undefined,
        alcoholPercent: 0,
        volume: 0.75,
        color: WineColorEnum.ROUGE,
        quantity: undefined,
        price: undefined,
      }
    : {
        wineName: "",
        year: undefined,
        alcoholPercent: undefined,
        volume: 0.75,
        color: undefined,
        price: undefined,
        quantity: undefined,
      };

  const { append, remove, fields } = useFieldArray({
    control: methods.control,
    name: "deliveryContent",
  });

  const watch = useWatch({
    control: methods.control,
    name: "deliveryContent",
  });

  const handleAddProduct = async () => {
    append(defaultValues as any);
  };

  const totalPrice =
    roundNumberToFixed(
      watch?.reduce(
        (acc: number, item) => acc + Number(item.price || 0) * Number(item.quantity || 0),
        0,
      ),
      2,
    ) + " €";

  const totalBtls = roundNumberToFixed(
    watch?.reduce((acc: number, item) => acc + Number(item.quantity || 0), 0),
    2,
  );

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg bg-blue-50 p-4">
      <div className="flex w-full flex-col items-center justify-center gap-4">
        <div className="flex flex-row items-center gap-2 self-start">
          <div className="bg-brand600 rounded-full px-3 py-1 text-xl font-bold text-white">
            <p className="text-xl font-bold text-white">2</p>
          </div>
          <p className="text-xl font-bold">
            {reExpedition ? t("infoBottles.reExpeditionTitle") : t("infoBottles.title")}
          </p>
        </div>
        <div className="flex w-full flex-col gap-2">
          {fields.map((item, index: number) => (
            <div key={item.id}>
              <WineListElem
                key={item.id}
                index={index}
                remove={() => remove(index)}
                error={methods.formState.errors.deliveryContent?.[index] !== undefined}
                hasScannedInvoice={hasScannedInvoice}
              />
            </div>
          ))}
        </div>
        <div className="flex w-full flex-row items-center justify-end gap-3">
          <Button onClick={() => handleAddProduct()} type="button" variant="outline">
            {t("infoBottles.addProduct")}
          </Button>
        </div>
      </div>
      <div
        className={
          "flex min-w-1/3 items-center justify-evenly gap-4 self-center rounded-lg border bg-gray-50 p-4"
        }
      >
        <DisplayCaracteristic
          name={t("infoBottles.totalBottles")}
          value={totalBtls}
          className="flex-1 items-center justify-center"
        />

        <div className="h-10 w-px bg-gray-200" />
        <DisplayCaracteristic
          name={t("infoBottles.totalPrice")}
          value={totalPrice}
          className="flex-1 items-center justify-center"
        />
      </div>
    </div>
  );
};
